import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'

import { classNames } from '../constants';

class NavNextView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id);
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container);
    this.initScrollTriggers();
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
  }
  /**
   * #######################
   * ### Scroll Triggers ###
   */
  initScrollTriggers = () => {
    // toggle body class + chapter-full transparent bg
    gsap.to('.chapter-full', {
      scrollTrigger: {
        toggleActions: "play none none reverse",
        trigger: this.container,
        start: 'top bottom',
        toggleClass: {targets: 'body', className: classNames.ITEM_NAV_NEXT},
        // markers: true,
      },
      backgroundColor: '#000000',
      duration: .4,
    });
  }
  /**
   * ### End: Scroll Triggers ###
   * ############################
   */

}

export default NavNextView